var map = {
	"./AED.png": 5751,
	"./AMD.png": 9304,
	"./AUD.png": 50,
	"./AZN.png": 7949,
	"./CAD.png": 159,
	"./CHF.png": 4198,
	"./CHF2.png": 2940,
	"./CNY.png": 1662,
	"./DKK.png": 623,
	"./DKK1.png": 8802,
	"./DKK2.png": 1036,
	"./DKK4.png": 7442,
	"./EUR.png": 4261,
	"./GBP.png": 7775,
	"./GEL.png": 4470,
	"./IQD.png": 8155,
	"./JPY.png": 5824,
	"./JPY2.png": 1309,
	"./JPY3.png": 3354,
	"./KPW.png": 7073,
	"./KWD.png": 4130,
	"./MYR.png": 5036,
	"./NOK.png": 1544,
	"./OMR.png": 5252,
	"./RUB.png": 9190,
	"./RUP.png": 8911,
	"./SAR.png": 7848,
	"./SAR2.png": 5910,
	"./SEK.png": 8278,
	"./SGD.png": 3774,
	"./THB.png": 8287,
	"./TRY.png": 6729,
	"./USD.png": 4462,
	"./coinImg.png": 1224,
	"./emamiImg.png": 3032,
	"./flag.png": 3757
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5729;